import { Section } from "@/components/layout/section/Section";

import ProductsShowCase from "@/components/product/ProductsShowCase";
import { Button } from "@/components/ui/button";
import { useProductsWithAccuratePricingResults } from "@/hooks";
import type { TypesenseProduct } from "@/lib/typesense";
import { useFeaturedProducts } from "@/queries/products";
import { useSellersMap } from "@/queries/sellers";
import { mergedStatus } from "@/queries/utils";
import { getRandom } from "@/utils/random";
import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import React, { useMemo } from "react";

// const FIDDLERS = [
//   "prod_01KCZ92R75FE3TQ0P4WC82GH3Z",
//   "prod_01KCZ92RGS6VG6NZY6F42DKXEA",
//   "prod_01KCZ92R756D92SJ9JFNVEHQ5D",
//   "prod_01KCZ92RGSAB40TH55F0YW15ET"
// ];

function RecommendedForYou() {
  const sellersMapQuery = useSellersMap();
  const featuredProductsQuery = useFeaturedProducts();
  const { data: featured } = featuredProductsQuery;
  const { status } = mergedStatus([featuredProductsQuery, sellersMapQuery]);

  const randomSelection: TypesenseProduct[] = useMemo(() => {
    if (!featured?.products) {
      return [];
    }

    // return featured.products.filter((item) => {
    //   return FIDDLERS.includes(item.id);
    // });

    return getRandom(featured.products, 4);
  }, [featured?.products]);

  const { products, pricingStatus, offerPriceState } =
    useProductsWithAccuratePricingResults(randomSelection);

  return (
    <Section
      title="Recommended for you"
      description="Products that we think you'll like"
      rightContent={
        <Button variant="outline" asChild>
          <Link to="/search">
            See All Recommendations
            <ChevronRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      }
    >
      <ProductsShowCase
        status={status}
        items={products}
        pricingStatus={pricingStatus}
        offerPriceState={offerPriceState}
      />
    </Section>
  );
}

export default React.memo(RecommendedForYou);
